import './ThankYouCallout.scss'

import { Callout } from '@tallink/components-lib'
import * as PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function ThankYouCallout({ email, price }) {
  const { t } = useTranslation()

  return (
    <Callout
      body={<p dangerouslySetInnerHTML={{ __html: t('confirmation.thankYouCallout.message', { email }) }} />}
      summary={
        <div className="thank-you-callout-summary">
          <span className="label">{t('confirmation.thankYouCallout.paidTotal')}</span>
          <span className="price"> {price} €</span>
        </div>
      }
      title={t('confirmation.thankYouCallout.title')}
    />
  )
}

ThankYouCallout.propTypes = {
  email: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired
}
